import { useRef, useState } from 'react'

import { Address as AddressPolicyHolder } from '../../@types/PolicyHolderDetails'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { useClickedOutside } from '../../hooks/useClickedOutside'
import { EditIcon, Plus } from '../Icons'
import { Select } from './styles'

export const SelectedPolicyholderAddress = ({
  addresses,
}: {
  addresses: AddressPolicyHolder[]
}) => {
  const ref = useRef<any>()
  const [open, setOpen] = useState(false)
  const [selectAddress, setSelectAddress] = useState('')
  const { setPolicyholderAddressSelected } = usePolicyholderDetailsStore()

  useClickedOutside(open, setOpen, ref)

  return (
    <>
      <span className="select-address" onClick={() => setOpen((prev) => !prev)}>
        <div className="align">
          {selectAddress.length > 0 || (addresses || [])?.length === 1 ? (
            <EditIcon color="#0093b2" width={28} height={28} />
          ) : (
            <Plus color="#0093b2" />
          )}
          {(addresses || [])?.length === 1 ? (
            <span className="excerpt">
              {addresses?.[0]?.typology?.postalAddress?.fullAddress || ''}
            </span>
          ) : (
            <span className="excerpt">{selectAddress}</span>
          )}
        </div>
      </span>
      {open && (
        <Select>
          <div ref={ref} className="select">
            {addresses?.map((address, index) => (
              <li
                key={index}
                onClick={() => {
                  setSelectAddress(
                    address?.typology?.postalAddress?.fullAddress || '',
                  )
                  setPolicyholderAddressSelected(address)
                  setOpen(false)
                }}
              >
                {address?.typology?.postalAddress?.fullAddress || ''}
              </li>
            ))}
          </div>
        </Select>
      )}
    </>
  )
}
